import React, { useMemo } from 'react';
import './style.scss';
import { API_FightResults } from 'shared';
import FightResultsCreamBlock from './cream';
import FightResultsLevelBlock from './level';
import clsx from 'clsx';
import SVGFightWin from '../../../../../assets/images/fightResults/win';
import SVGFightDraw from '../../../../../assets/images/fightResults/draw';
import SVGFightLose from '../../../../../assets/images/fightResults/lose';

interface Props {
  data: API_FightResults;
  className?: string;
}

type HeaderData = {
  Component: typeof SVGFightWin;
  wording: string;
};

const FightResultsInfo = ({ data, className }: Props) => {
  const header = useMemo<HeaderData>(() => {
    if (data.selfWinner)
      return { Component: SVGFightWin, wording: 'Well Done!' };
    if (data.isDraw) return { Component: SVGFightDraw, wording: 'Draw!' };
    return { Component: SVGFightLose, wording: 'Oh No!' };
  }, [data]);

  return (
    <div className={clsx('fight-results-info', className)}>
      <header.Component className='fri-header-svg' />
      <h1 className='fri-header'>{header.wording}</h1>
      <div className='fri-content'>
        <FightResultsCreamBlock
          isWin={data.selfWinner}
          isDraw={data.isDraw}
          bet={data.bet}
          className={clsx(
            'fri-cream-wrapper',
            (!data.selfWinner || data.isDraw) && 'fri-cream-wrapper-plain'
          )}
        />
        <FightResultsLevelBlock
          newLevel={data.nftData.level}
          levelChange={data.levelChange}
          oldRank={data.nftData.oldRank}
          newRank={data.nftData.rank}
          className='fri-level-wrapper'
        />
      </div>
    </div>
  );
};

export default FightResultsInfo;
